import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface YoutubeVideoUrlModel extends BaseModel {
  variables?: { [key: string]: string } | YoutubeVideoUrlVariables;
}

export interface YoutubeVideoUrlVariables {
  Link: string;
}

export class YoutubeVideoUrlInitVariables implements YoutubeVideoUrlVariables {
  Link = '';
}

export class YoutubeVideoUrlInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new YoutubeVideoUrlInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
